import { useCallback, useState } from 'react';

import { DEFAULT_PER_PAGE } from '../constants';

const usePagination = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    from: 0,
    perPage: DEFAULT_PER_PAGE,
    to: 0,
    totalPages: 1,
    totalRecords: 0,
  });

  const handlePageChange = useCallback((page) => {
    setPagination((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  }, []);

  const updatePagination = useCallback(
    ({ current: currentPage, last: lastPage, records: totalRecords }) => {
      const from = totalRecords === 0 ? 0 : (currentPage - 1) * pagination.perPage + 1;
      const to = Math.min(currentPage * pagination.perPage, totalRecords);
      const totalPages = lastPage || currentPage;

      setPagination((prevState) => ({
        ...prevState,
        currentPage,
        from,
        to,
        totalPages,
        totalRecords,
      }));
    },
    [pagination.perPage]
  );

  return {
    handlePageChange,
    pagination,
    updatePagination,
  };
};

export default usePagination;
